import api from './api';

const loadingScreenApi = {
  // Get loading screen settings and cards
  getSettings: async () => {
    try {
      const response = await api.get('/loading-screen/settings');
      return response.data;
    } catch (error) {
      console.error('Error fetching loading screen settings:', error);
      throw error;
    }
  },

  // Update loading screen settings
  updateSettings: async (settings) => {
    try {
      const response = await api.put('/loading-screen/settings', settings);
      return response.data;
    } catch (error) {
      console.error('Error updating loading screen settings:', error);
      throw error;
    }
  },

  // Get all loading screen cards
  getCards: async () => {
    try {
      const response = await api.get('/loading-screen/cards');
      return response.data;
    } catch (error) {
      console.error('Error fetching loading screen cards:', error);
      throw error;
    }
  },

  // Create new loading screen card
  createCard: async (cardData) => {
    try {
      const response = await api.post('/loading-screen/cards', cardData);
      return response.data;
    } catch (error) {
      console.error('Error creating loading screen card:', error);
      throw error;
    }
  },

  // Update loading screen card
  updateCard: async (id, cardData) => {
    try {
      const response = await api.put(`/loading-screen/cards/${id}`, cardData);
      return response.data;
    } catch (error) {
      console.error('Error updating loading screen card:', error);
      throw error;
    }
  },

  // Delete loading screen card
  deleteCard: async (id) => {
    try {
      const response = await api.delete(`/loading-screen/cards/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting loading screen card:', error);
      throw error;
    }
  },

  // Update card sort order
  updateCardSort: async (cards) => {
    try {
      const response = await api.put('/loading-screen/cards/sort', { cards });
      return response.data;
    } catch (error) {
      console.error('Error updating card sort order:', error);
      throw error;
    }
  }
};

export default loadingScreenApi; 